export default __webpack_public_path__ + "static/media/cabinet001.00f45166.jpeg";